import React, { useEffect, useState } from "react";
import MainContainer from "../../container/MainContainer";
import search from "../../images/search.svg";
import { useSubscription } from "@apollo/client";
import { GET_USERS_LIST } from "../../subscription/getUsersList";
import { VIEW_MESSAGE } from "../../subscription/viewMessage";
import { hasuraWsClient } from "../../apolloClient";
import moment from "moment";

const MessageBusiness = () => {
  const [senderAdminUserId, setSenderAdminUserId] = useState(null);
  const [selectedAdminName, setSelectedAdminName] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(null);
  const [selectedAdminPic, setSelectedAdminPic] = useState(null);
  const [isNew, setIsNew] = useState(true);

  const { data: userData } = useSubscription(GET_USERS_LIST, {
    fetchPolicy: "network-only",
    client: hasuraWsClient,
    variables: {
      business_user_id: localStorage.getItem("user_id"),
      search_text: `%${searchText}%`,
    },
  });

  const { data: messageData } = useSubscription(VIEW_MESSAGE, {
    fetchPolicy: "network-only",
    client: hasuraWsClient,
    variables: {
      sender_admin_user_id: senderAdminUserId,
      business_user_id: senderAdminUserId
        ? localStorage.getItem("user_id")
        : null,
    },
  });

  useEffect(() => {
    if (
      userData &&
      userData.admin_business_last_message_history_view &&
      userData.admin_business_last_message_history_view.length &&
      isNew
    ) {
      setSenderAdminUserId(
        userData.admin_business_last_message_history_view[0]?.admin_user?.id
      );
      setSelectedAdminName(
        userData.admin_business_last_message_history_view[0]?.admin_user
          ?.full_name
      );
      setSelectedAdminPic(
        userData.admin_business_last_message_history_view[0]?.admin_user
          ?.profile_photo_url
      );
      setCurrentIndex(0);
      setIsNew(false);
    }
  }, [userData]);

  return (
    <MainContainer>
      <section className="message-business">
        {/* <div className="main-title">
                    <div className="back-button">
                        <Link to="/deals">
                            <img src={Arrow} alt="arrow right" />
                        </Link>
                        <h2>Deals</h2>
                    </div>
                </div> */}
        <div className="message-box">
          <div className="col-left">
            <div className="search-box">
              <input
                type="search"
                className="form-control"
                placeholder="Search ..."
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
              />
              <button className="icon">
                <img src={search} alt="Search icon" />
              </button>
            </div>

            <ul className="message-list">
              {userData?.admin_business_last_message_history_view?.map(
                (item, index) => (
                  <li
                    className={currentIndex === index ? "active" : ""}
                    onClick={() => {
                      setSenderAdminUserId(item?.admin_user?.id);
                      setSelectedAdminName(item?.admin_user?.full_name);
                      setSelectedAdminPic(item?.admin_user?.profile_photo_url);
                      setCurrentIndex(index);
                    }}
                  >
                    <div className="message-list-box">
                      <div className="deals-photo">
                        <img
                          src={item?.admin_user?.profile_photo_url}
                          alt="usear photo"
                        />
                      </div>
                      <div className="deals-details">
                        <h3> {item?.admin_user?.full_name} </h3>
                        <div className="details">
                          {/* <p>
                              {item?.message?.length > 20 ? (
                                <>{item?.message?.slice(0, 20)}...</>
                              ) : (
                                item?.message
                              )}
                            </p> */}

                          <p>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: item?.message ?? "",
                              }}
                            ></div>
                          </p>
                          <label>
                            {moment(item?.sent_at).startOf().fromNow()}
                          </label>
                        </div>
                      </div>
                    </div>
                  </li>
                )
              )}
            </ul>
          </div>

          <div className="col-right">
            {senderAdminUserId ? (
              <div className="col-right-cover">
                <div className="message-header">
                  <div className="user-photo">
                    <img src={selectedAdminPic} alt="user photo" />
                  </div>
                  <div className="message-details">
                    <h1>{selectedAdminName}</h1>
                  </div>
                </div>
                <div className="message-box-cover">
                  {messageData?.chat_messages?.map((item) => (
                    <div className="message-box-top">
                      <div className="message-box-header">
                        <div className="user-photo">
                          <img
                            src={item?.admin_user?.profile_photo_url}
                            alt="user photo"
                          />
                        </div>
                        <div className="user-name">
                          <h3>{item?.admin_user?.full_name}</h3>
                          <label>
                            <span>{moment(item?.created_at).format("LT")}</span>{" "}
                            -{" "}
                            <span>
                              {moment(item?.created_at).startOf().fromNow()}
                            </span>
                          </label>
                        </div>
                      </div>
                      {/* <h2>40% off Brunch Inquiry</h2> */}
                      {/* <p>{item?.message} </p> */}
                      <p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item?.message ?? "",
                          }}
                        ></div>
                      </p>
                      {/* <p>Please email: Steve.banks@gmail.com</p> */}
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </section>
    </MainContainer>
  );
};

export default MessageBusiness;
